import { render, staticRenderFns } from "./DeliveryEditStatus_Items.vue?vue&type=template&id=4b0f99f6&"
import script from "./DeliveryEditStatus_Items.vue?vue&type=script&lang=js&"
export * from "./DeliveryEditStatus_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports